import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { useWatchlist } from '@terminal/stores/use-watchlist/useWatchlist';
import { Watchlist } from '@terminal/stores/use-watchlist/watchlist-types';
import { useWatchlistManagerWidget } from '@terminal/stores/use-watchlist-manager-widget/useWatchlistManagerWidget';
import { useParams } from 'react-router';

export const useWatchlistManagerMode = () => {
  const { watchlistId: watchlistIdFromRoute } = useParams();
  const { params } = useQueryParams();
  const watchlistIdFromQuery = params[queryKeys.watchlistId];
  const watchlistId = watchlistIdFromQuery ?? watchlistIdFromRoute;

  const { lists } = useWatchlist(state => ({
    lists: state.lists,
  }));

  const { isAddMode, isEditMode, onConfirmCallback, shouldResetList } =
    useWatchlistManagerWidget(state => ({
      isAddMode: state.isAddMode,
      isEditMode: state.isEditMode,
      onConfirmCallback: state.onConfirmCallback,
      shouldResetList: state.shouldResetList,
    }));

  const activeListInAddMode: Watchlist | undefined =
    isAddMode && watchlistId
      ? lists.find(list => list.id === watchlistId)
      : undefined;

  const activeListInEditMode: Watchlist | undefined =
    isEditMode && watchlistId
      ? lists.find(list => list.id === watchlistId)
      : undefined;

  const activeList = activeListInAddMode ?? activeListInEditMode;

  const activeTags = shouldResetList
    ? []
    : (activeList?.entities.map(e => e.tag) ?? []);

  return {
    watchlistId,
    isAddMode,
    isEditMode,
    onConfirmCallback,
    shouldResetList,
    activeListInAddMode,
    activeListInEditMode,
    activeTags,
  };
};
